var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "slider-input" }, [
    _c(
      "label",
      { staticClass: "slider-input__label", attrs: { for: _vm.inputId } },
      [_vm._v(_vm._s(_vm.label))]
    ),
    _c("div", { staticClass: "slider-input__row" }, [
      _c("input", {
        staticClass: "slider-input__range",
        attrs: {
          id: _vm.inputId,
          type: "range",
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          "aria-valuemin": _vm.min,
          "aria-valuemax": _vm.max,
          "aria-valuenow": _vm.unwrappedValue,
          "aria-valuetext": `${_vm.displayValue}${
            _vm.unit ? ` ${_vm.unit}` : ""
          }`,
          role: "slider",
        },
        domProps: { value: _vm.unwrappedValue },
        on: { input: _vm.onInput },
      }),
      _c(
        "span",
        {
          staticClass: "slider-input__value",
          attrs: { "aria-live": "polite" },
        },
        [
          _vm._v(" " + _vm._s(_vm.displayValue)),
          _vm.unit ? [_vm._v(_vm._s(_vm.unit))] : _vm._e(),
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "slider-input__limits" }, [
      _c(
        "span",
        [
          _vm._v(_vm._s(_vm.min)),
          _vm.unit ? [_vm._v(_vm._s(_vm.unit))] : _vm._e(),
        ],
        2
      ),
      _c(
        "span",
        [
          _vm._v(_vm._s(_vm.max)),
          _vm.unit ? [_vm._v(_vm._s(_vm.unit))] : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }